// extracted by mini-css-extract-plugin
module.exports = {"main-component":"downArrowReport_main-component__1reAQ"};